import { render, staticRenderFns } from "./onpiste-app.vue?vue&type=template&id=0848306a&"
import script from "./onpiste-app.vue?vue&type=script&lang=ts&"
export * from "./onpiste-app.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports